module.exports = __webpack_public_path__ + "img/supporter-2.76a49185.png";